import { useState } from 'react';

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { logOut, selectUser } from '../userSlice';

export function Header() {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [activeKey, setActiveKey] = useState('/admin/sku');

  return (
    <Navbar as="header" bg="dark" sticky="top" variant="dark">
      <Navbar.Brand as="span">HomeKit</Navbar.Brand>
      <Navbar.Toggle aria-controls="adminPageHeader" />
      {user.isLoggedIn && (
        <Navbar.Collapse id="adminPageHeader">
          <Nav
            activeKey={activeKey}
            as="ul"
            className="mr-auto"
            onSelect={(key) => setActiveKey(key)}
          >
            <Nav.Item as="li">
              <Nav.Link as={Link} eventKey={'/admin/sku'} to="/admin/sku">
                SKU
              </Nav.Link>
            </Nav.Item>
            <Nav.Item as="li">
              <Nav.Link
                as={Link}
                eventKey={'/admin/customer'}
                to="/admin/customer"
              >
                Khách Hàng
              </Nav.Link>
            </Nav.Item>
            <Nav.Item as="li">
              <Nav.Link
                as={Link}
                eventKey={'/admin/product'}
                to="/admin/product"
              >
                Sản Phẩm
              </Nav.Link>
            </Nav.Item>
            <Nav.Item as="li">
              <Nav.Link
                as={Link}
                eventKey={'/admin/product/serial-check'}
                to="/admin/product/serial-check"
              >
                Kiểm Tra Serial
              </Nav.Link>
            </Nav.Item>
            <Nav.Item as="li">
              <Nav.Link as={Link} eventKey={'/admin/report'} to="/admin/report">
                Xuất Serial
              </Nav.Link>
            </Nav.Item>
            {user.role === 'admin' && (
              <Nav.Item as="li">
                <Nav.Link
                  as={Link}
                  eventKey={'/admin/operator'}
                  to="/admin/operator"
                >
                  Operator
                </Nav.Link>
              </Nav.Item>
            )}
          </Nav>
          <Nav as="ul">
            <Nav.Item as="li">
              <Nav.Link
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(logOut());
                }}
              >
                Đăng Xuất
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      )}
    </Navbar>
  );
}
